<template>
	<b-modal
		scrollable
		no-fade
		ok-only
		ok-title="Asignar"
		title="Asignar estado"
		static
		id="modal-assign-status-view"
		size="md"
		body-class="position-static"
		@ok="onSubmit"
		>
			<b-overlay :show="loadingUpdate" no-wrap></b-overlay>
			<p class="mb-0">{{rowsMessage}}</p>
			<b-form-group label="Estado">
				<b-form-select size="sm" v-model="status" :options="transportStatusOpts" required />
			</b-form-group>

			<b-form-group label="Seleccione la razon de cambio de estado">
				<b-overlay
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					:show="loading"
				>
					<VueTreeList v-if="reasonsOptions" :model="reasonsOptions">
						<template v-slot:leafNameDisplay="slotProps">
							<span v-if="!slotProps.model.children">
								<b-form-checkbox
									v-model="reasonStatedId"
									:value="slotProps.model.id"
									:unchecked-value="null"
								>
									{{ slotProps.model.label }}
								</b-form-checkbox>
							</span>
							<span v-else>
								{{ slotProps.model.label }}
							</span>
						</template>
					</VueTreeList>
					<b-alert show variant="warning" v-if="notReason"
						>No se encontro ninguna razon de estado</b-alert
					>
				</b-overlay>
			</b-form-group>
	</b-modal>
</template>

<script>
import api from '../../../api.js'
import { VueTreeList, Tree } from "vue-tree-list";

export default {
	methods: {
		onSubmit(event) {
			event.preventDefault();
			if (this.status == '') {
				this.$root.showAlert('No se ha seleccionado un estado',{ variant:'warning' })
				return;
			}
			let aux = {
				ids: this.selected,
				status : this.status,
				reasonStateId: this.reasonStatedId,
			}
			this.loadingUpdate = true
			api(this).post(`/transport-services/massive-update-status`, aux ).then(() => {
				this.loadingUpdate = false
				this.$root.showAlert('Actualización exitosa');
				this.$root.$emit('bv::refresh::table', 'reservations-index-list');
				this.$emit('update:selected',[])
				this.$root.$emit(
					"bv::hide::modal",
					"modal-assign-status-view",
					event.target
				);
			}).catch(err => {
				this.$root.handleRequestError(err)
			});
		},
		async loadReasonOptions(status) {
			this.reasonsOptions = null;
			this.notReason = false;
			this.reasonStatedId = null;
			this.loading = true;
			await this.$root.auxVars.loadResourcesOpts({
				vm: this,
				resourceNames: ["reasonStatesActive"]
			});
			const aux = JSON.parse(JSON.stringify(this.reasonStateActiveOpts.filter(({ toStatus }) => toStatus === status)));
			if (aux.length === 0) {
				this.notReason = true;
			} else {
				this.notReason = false;
				this.reasonsOptions = new Tree(
					this.map(aux)
				);
			}
			this.loading = false;
		},
		map(arr) {
			return arr ? arr.map(this.fix) : null;
		},
		fix(item) {
			item.dragDisabled = true;
			item.addTreeNodeDisabled = true;
			item.addLeafNodeDisabled = true;
			item.editNodeDisabled = true;
			item.delNodeDisabled = true;
			console.log('asd')
			if (item.children)
				return {
					...item,
					children: this.map(item.children)
				};
			delete item.children;
			return item;
		},
	},
	props: {
		selected: {
			type : Array,
			required: true
		},
	},
	components: {
		VueTreeList,
	},
	data(){
		return {
			status:'',
			reasonsOptions: null,
			reasonStatedId: null,
			notReason: false,
			loading: false,
			errorReason: false,
			loadingUpdate:false,
		}
	},
	computed:{
		transportStatusOpts(){
			return this.$root.auxVars.transportServiceStatusOpts
		},
		reasonStateActiveOpts() {
			return this.$root.auxVars.reasonStateActiveOpts;
		},
		rowsMessage(){ return 'Ha seleccionado '+this.selected.length+' registros para actualizar.' },
	},
	mounted(){
	},
	watch:{
		status(v){
			this.loadReasonOptions(v)
		}
	}
}
</script>
